const analyticMicrosoftTeams = (Analytic) => {
    Analytic.prototype.teamsPreviewChallenge = function (challenge) {
        this.track('Microsoft Teams Preview Challenge', {
            challenge_code: challenge.code,
            challenge_name: challenge.name
        })
    }
}

export default analyticMicrosoftTeams